(function () {
  'use strict';

  if (customElements.get('product-reviews-modal')) return;

  /**
   * <product-reviews-modal>
   * One or more [data-reviews-open] triggers ("See all N reviews" on desktop,
   * a "See more" on every mobile rail card) + a scrollable <dialog> with every
   * review. A trigger may carry data-reviews-target="<id>" to scroll that
   * review into view once the dialog is open.
   * Esc / backdrop / close button dismiss; focus returns to the trigger used.
   *
   * The body scroll unlock runs in every close path directly (button,
   * backdrop, Esc via 'cancel') as well as on 'close' — some embedded
   * browsers don't deliver the dialog 'close' event reliably.
   */
  class ProductReviewsModal extends HTMLElement {
    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[data-reviews-open]'));
      this.dialog = this.querySelector('dialog');
      if (!this.triggers.length || !this.dialog) return;

      this.onOpen = this.onOpen.bind(this);
      this.onClosed = this.onClosed.bind(this);
      this.onBackdrop = this.onBackdrop.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);

      this.triggers.forEach((t) => t.addEventListener('click', this.onOpen));
      this.dialog.addEventListener('click', this.onBackdrop);
      this.dialog.addEventListener('close', this.onClosed);
      this.dialog.addEventListener('cancel', this.onClosed);
      this.closeBtn = this.querySelector('[data-reviews-close]');
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.onCloseClick);

      this.markClamped();
      this.onResize = this.markClamped.bind(this);
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      if (this.triggers) this.triggers.forEach((t) => t.removeEventListener('click', this.onOpen));
      if (this.dialog) {
        this.dialog.removeEventListener('click', this.onBackdrop);
        this.dialog.removeEventListener('close', this.onClosed);
        this.dialog.removeEventListener('cancel', this.onClosed);
      }
      if (this.closeBtn) this.closeBtn.removeEventListener('click', this.onCloseClick);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }

    /* Rail cards clamp their text; only show "See more" when text was actually cut. */
    markClamped() {
      this.querySelectorAll('.product-reviews__rail-card').forEach((card) => {
        const text = card.querySelector('.product-reviews__text');
        const clamped = !!text && text.scrollHeight > text.clientHeight + 1;
        card.classList.toggle('is-clamped', clamped);
      });
    }

    onOpen(event) {
      this.lastTrigger = event.currentTarget;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      const id = this.lastTrigger.getAttribute('data-reviews-target');
      const target = id ? this.dialog.querySelector('#' + id) : null;
      if (target) target.scrollIntoView({ block: 'start' });
      else this.dialog.querySelector('.product-reviews__dialog-list').scrollTop = 0;
    }

    onClosed() {
      document.body.style.overflow = '';
      if (this.lastTrigger) this.lastTrigger.focus();
    }

    onCloseClick() {
      this.dialog.close();
      this.onClosed();
    }

    onBackdrop(event) {
      if (event.target === this.dialog) {
        this.dialog.close();
        this.onClosed();
      }
    }
  }

  customElements.define('product-reviews-modal', ProductReviewsModal);
})();
